<script setup lang="ts">
const inkQueue: any = ref([])
const rippleInk = ref()
const handleMouseDown = (e: { clientX: number; clientY: number }) => {
  const rect = rippleInk.value.getBoundingClientRect()
  const x = e.clientX - rect.left
  const y = e.clientY - rect.top
  let max
  if (rect.width === rect.height) {
    max = rect.width * Math.SQRT2
  } else {
    max = Math.sqrt(rect.width * rect.width + rect.height * rect.height)
  }
  const size = `${max * 2}px`
  inkQueue.value.push({
    key: Math.random(),
    width: size,
    height: size,
    marginLeft: `${x - max}px`,
    marginTop: `${y - max}px`,
    isHolding: false,
    isDone: false,
  })
  setTimeout(() => {
    if (inkQueue.value.length > 0) {
      inkQueue.value[inkQueue.value.length - 1].isHolding = true
    }
  })
}
const handleMouseUp = () => {
  if (inkQueue.value.length > 0) {
    inkQueue.value[inkQueue.value.length - 1].isDone = true
    setTimeout(() => {
      inkQueue.value.shift()
    }, 650)
  }
}
</script>

<template>
  <div
    ref="rippleInk"
    class="ripple-ink rounded-inherit overflow-hidden absolute left-0 top-0 right-0 bottom-0"
    @mousedown="handleMouseDown"
    @mouseup="handleMouseUp"
  >
    <div
      v-for="ink in inkQueue"
      :key="ink.key"
      :style="{
        width: ink.width,
        height: ink.height,
        marginLeft: ink.marginLeft,
        marginTop: ink.marginTop,
      }"
      class="ink absolute w-0 h-0 rounded-1/2 bg-op-10 bg-white"
      :class="[ink.isHolding ? 'is-holding' : '', ink.isDone ? 'is-done' : '']"
    />
  </div>
</template>

<style lang="less" scoped>
.ripple-ink {
  .ink {
    transform: scale(0);
    transition:
      transform 0.6s ease-out,
      opacity 0.6s ease-out;

    &.is-holding {
      opacity: 0.4;
      transform: scale(1);

      &.is-done {
        opacity: 0;
      }
    }
  }
}
</style>
